<div class="w-full h-screen flex flex-col">

  <main class="flex flex-col mx-auto w-full max-w-7xl px-0 sm:px-6 lg:px-8">

    <div class="mx-auto max-w-7xl bg-white dark:bg-indigo-custom w-full h-[calc(100%-0.75rem)]">

      <div class="mt-8">

        <!--
        <h1 class="text-2xl text-center font-medium mb-12 w-full">What’s your P as sales Person?</h1>
        -->

        <!-- Context -->
        <section class="mb-9">
          <h3 class="text-secondary text-lg font-medium mb-3">Context</h3>

          <p class="text-secondary mb-3">
            Researchers* have found an answer to what increases salespeople’s job satisfaction, customers’ satisfaction and selling performance. It is called is adaptive selling and it refers to a salesperson’s capacity to change their behaviours (ranging from nonverbal cues to information sharing or entire sale strategy) based upon real time feedback and perceived information about the nature of the selling situation, the needs, and preferences of the customer. That is way easier said than done!
          </p>

          <p class="text-secondary">
            Many factors contribute to the development of adaptive selling skills*. Some of them depend upon the firm’s customer orientation, but some depend upon the salesperson motivations and skills. We invite you to explore your own profile of skills & motivations and see where your’re standing now and how you could get more job satisfaction and better sales.
          </p>
        </section>
        <!-- / Context -->

        <section class="blue-card p-6 mb-9">
          <h2 *ngIf="emp >= 21 && comp < 12" class="text-2xl font-semibold text-[#63ABFD] mb-6">Your P as sales person is The Popular</h2>
          <h2 *ngIf="emp >= 21 && comp >= 12" class="text-2xl font-semibold text-[#63ABFD] mb-6">Your P as sales person is The Performer</h2>
          <h2 *ngIf="emp < 21 && comp < 12" class="text-2xl font-semibold text-[#63ABFD] mb-6">Your P as sales person is The Procrastinator</h2>
          <h2 *ngIf="emp < 21 && comp >= 12" class="text-2xl font-semibold text-[#63ABFD] mb-6">Your P as sales person is The Pusher</h2>

          <div class="grid grid-cols-2 gap-6 mb-6">

            <div class="relative w-[25rem] h-[25rem]">

              <app-quadrant-chart
                [xValue]="xValue"
                [yValue]="yValue"
                [personalityType]="personalityType">
              </app-quadrant-chart>

            </div>

            <!-- The Popular (Emp>=21; Comp<12) -->
            <div *ngIf="emp >= 21 && comp < 12">
              <ul class="text-secondary font-light list-disc space-y-3">
                <li>Everyone likes you, as you are capable of understanding others’ points of view and create close relationships.</li>
                <li>Nice guys or gals.</li>
                <li>You get along with customers, understand their needs and preferences, you bring them near the closing point, but somehow you don’t manage to close the deal – maybe you value the relationship more than closing the deal and you’re afraid of losing it, maybe you are too concerned with what the customers might be feeling or thinking.</li>
                <li>High job satisfaction, as you see value in your interactions & relationships, not only on closing the deals.</li>
              </ul>
            </div>

            <!-- The Performer (Emp>=21; Comp>=12) -->
            <div *ngIf="emp >= 21 && comp >= 12">
              <ul class="text-secondary font-light list-disc space-y-3">
                <li>You know how to use your empathy persuasively, you can sense the reactions of the customers and adjust to these reactions, functioning in terms of real interaction between yourself and the customer – you can change pace, double back on the track and make whatever creative changes might be necessary to home in on the target and close the sale.</li>
                <li>You are probably in the top of your sales team and your job satisfaction is determined not only by the closed deals, but also by the value you find in interacting with the people in your job.</li>
              </ul>
            </div>

            <!-- The Procrastinator (Emp<21; Comp<12) -->
            <div *ngIf="emp < 21 && comp < 12">
              <ul class="text-secondary font-light list-disc space-y-3">
                <li>You are often puzzled by the reactions of people around you as their motives, preferences and needs remain opaque to your understanding.</li>
                <li>You are trying to do a good job at presenting the information and then wait for the other to decide if your offer is of any interest, considering that their decision is out of your agency.</li>
                <li>Your job satisfaction tends to be fragile, as it is dependent on closing sales deals, which is something upon which you have limited control.</li>
              </ul>
            </div>

            <!-- The Pusher (Emp<21; Comp>=12) -->
            <div *ngIf="emp < 21 && comp >= 12">
              <ul class="text-secondary font-light list-disc space-y-3">
                <li>Your determination to win the sales hinders you from paying attention to the customers’ perspective – needs, relevant outcomes etc, therefore sometimes failing at closing. </li>
                <li>Your job satisfaction is fragile, as it is dependent on closing the deals.</li>
                <li>You need to develop your skills of seeing things from the other person’s perspective – this will help you understand better what clients’ needs and preferences and adapt your selling strategy.</li>
              </ul>
            </div>

          </div>

          <!-- Find out more about your empathy level? -->
          <div class="mb-9">
            <h3 class="text-lg font-medium mb-3">Find out more about your empathy level?</h3>
            <p class="text-secondary">There are two facets under the concept of empathy: perspective taking is the cognitive capacity to consider the world from another individual’s viewpoint and allows an individual to anticipate the behavior and reactions of others. Empathic concern, in contrast, is an other-focused emotional response that allows one person to connect emotionally with another individual and feel sympathy and concern.</p>
          </div>

          <div class="mx-auto max-w-2xl">
            <h2 class="text-lg text-center font-medium mb-3">The structure of your empathy</h2>

            <!-- Scales -->
            <div *ngIf="testUser">

              <div *ngFor="let scale of testUser.scales" class="mb-12">

                <div class="flex items-center mb-3">
                  <span class="block w-3 h-3 rounded-full bg-[#63ABFD] mr-3"></span>
                  <span class="text-sm">{{ scale.name }}</span> <!-- Display scale name -->
                </div>

                <div class="progress-container">
                  <mat-progress-bar mode="determinate" [value]="scale.score" class="empathic-concern-progress-bar"></mat-progress-bar>
                  <span class="progress-percentage" [style.left.%]="scale.score">
                  {{ scale.score }}% <!-- Display scale score as percentage -->
                </span>
                </div>

              </div>

            </div>

            <!-- Empathic Concern -->
            <!--
            <div class="mb-6">

              <div class="flex items-center mb-3">
                <span class="block w-3 h-3 rounded-full bg-[#63ABFD] mr-3"></span>
                <span class="text-sm">Empathic Concern</span>
              </div>

              <div class="progress-container">
                <mat-progress-bar mode="determinate" [value]="empathicConcernProgress" class="empathic-concern-progress-bar"></mat-progress-bar>
                <span class="progress-percentage" [style.left.%]="empathicConcernProgress">
                  {{ empathicConcernProgress }}%
                </span>
              </div>

            </div>
            -->
            <!-- / Empathic Concern -->

            <!-- Perspective taking -->
            <!--
            <div>

              <div class="flex items-center mb-3 mt-3">
                <span class="block w-3 h-3 rounded-full bg-[#A155B9] mr-3"></span>
                <span class="text-sm">Perspective taking</span>
              </div>

              <div class="progress-container">
                <mat-progress-bar mode="determinate" [value]="perspectiveTakingProgress" class="perspective-taking-progress-bar"></mat-progress-bar>
                <span class="progress-percentage" [style.left.%]="perspectiveTakingProgress">
                  {{ perspectiveTakingProgress }}%
                </span>
              </div>

            </div>
            -->
            <!-- / Perspective taking -->

          </div>

        </section>

        <!-- Section -->
        <section class="grid grid-cols-2 gap-9 mb-9">
          <div>
            <p class="text-secondary">There is suggestive evidence* that perspective taking and empathic concern may not have the same effects in strategic interactions, such as complex sales. Perspective takers are, in general, able to uncover underlying interests to generate creative solutions when immediate deals are not visible, leading to greater collective and individual gains, than the empathic concerns. Thus, understanding the interests and motives of opponents in competitive decision-making interactions appears to be more valuable than connecting with them emotionally.</p>
          </div>
          <div class="blue-card flex items-center p-6">
            <p class="text-lg text-secondary">The current research suggests that in complex sales interactions and negotiations, it is better to ‘‘think for’’ than to ‘‘feel for’’ one’s negotiation partner —more beneficial to get inside their heads than to have them inside one’s own heart.</p>
          </div>
        </section>
        <!-- Section -->

        <!-- Section -->
        <section class="mb-9">
          <p class="text-secondary mb-9">
            Taking the perspective of one’s opponent produces both greater joint gains and more profitable individual outcomes, compared with considering one’s own role carefully.
            Perspective takers achieved the highest level of economic efficiency, without sacrificing their own material gains. In contrast, empathizing recruiters received the poorest individual outcomes; the increases in joint gains in this condition went mostly to the empathizers’ opponents.
            Extrapolating from the current data, we propose that the negotiator who achieves the best individual outcome is one who takes the perspective of an opponent who already feels empathy toward him or her.
          </p>
          <p class="text-secondary">
            Empathic concern leads to a great level of satisfaction of the other party, although not leading to direct self gain. It is therefore possible that the positive interpersonal capital empathizers build up in an initial negotiation could facilitate future agreements between negotiators, such that the outcome benefits of empathy may emerge over time.
            By increasing the other side’s satisfaction with the negotiation process, empathy may be particularly helpful in certain types of negotiations. For example, in disputes, negotiators often come to the table angry and with a desire to be heard, and empathy may help calm them and soften outbursts that can escalate conflict.
            Similarly, empathy may be particularly valuable in mediation, as negotiators involved in mediation often need to be satisfied with the process before agreeing to a deal.
          </p>
        </section>

        <div class="mx-auto max-w-5xl flex justify-center mb-6">
          <a href="/psy-testing" class="btn btn-blue text-center w-60">Back to PSY Testing</a>
        </div>

      </div>

    </div>

  </main>

</div>

<app-subscription-banner></app-subscription-banner>
